import React from "react";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Stack,
  Typography,
  Chip,
} from "@mui/material";
import {
  Search as SearchIcon,
  FilterList as FilterListIcon,
  Clear as ClearIcon,
  Close as CloseIcon,
  PersonOff as PersonOffIcon,
  ExitToApp as ExitToAppIcon,
} from "@mui/icons-material";
import { useTheme } from "@mui/material";
import { AccountCategoryKey } from "../../../../../utils/enums";

const StaffFilters = ({
  filters,
  accountCategoryOptions,
}) => {
  const theme = useTheme();

  const getCategoryIcon = (key) => {
    switch (key) {
      case AccountCategoryKey.NON_PERSON:
        return <PersonOffIcon fontSize="small" />;
      case AccountCategoryKey.OFFBOARDED_USER:
        return <ExitToAppIcon fontSize="small" />;
      default:
        return null;
    }
  };

  return (
    <>
      {accountCategoryOptions.length > 0 && (
        <Box sx={{ p: 1, pb: 1, backgroundColor: theme.customColors.background.main }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <FilterListIcon sx={{ color: "#6B7280", fontSize: 20 }} />
            <Typography
              variant="body2"
              color="#374151"
              fontWeight={600}
              sx={{ whiteSpace: "nowrap" }}
            >
              Account Type
            </Typography>
            <Box
              sx={{
                overflowX: "auto",
                display: "flex",
                gap: 1,
                flexWrap: "nowrap",
                py: 0.5,
              }}
            >
              {accountCategoryOptions.map((option) => {
                const isSelected = filters.selectedAccountCategory === option.key;
                return (
                  <Chip
                    key={option.key}
                    icon={getCategoryIcon(option.key)}
                    label={option.title}
                    onClick={() => {
                      filters.setSelectedAccountCategory(
                        isSelected ? null : option.key
                      );
                    }}
                    sx={{
                      cursor: "pointer",
                      height: "32px",
                      fontWeight: 600,
                      fontSize: "0.85rem",
                      borderRadius: "12px",
                      backgroundColor: isSelected ? "#3B82F6" : "#fff",
                      color: isSelected ? "#fff" : "#6B7280",
                      border: `2px solid ${isSelected ? "#3B82F6" : "#E5E7EB"}`,
                      boxShadow: isSelected
                        ? "0 4px 12px rgba(59, 130, 246, 0.2)"
                        : "none",
                      "& .MuiChip-icon": {
                        color: isSelected ? "#fff" : "#6B7280",
                      },
                      "&:hover": {
                        backgroundColor: isSelected ? "#2563EB" : "#F9FAFB",
                        borderColor: isSelected ? "#2563EB" : "#9CA3AF",
                      },
                    }}
                  />
                );
              })}
            </Box>
            {filters.selectedAccountCategory && (
              <IconButton
                size="small"
                onClick={() => filters.setSelectedAccountCategory(null)}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            )}
          </Stack>
        </Box>
      )}
    </>
  );
};

export default StaffFilters;

